module.exports = __webpack_public_path__ + "img/vignettes-asso_0006_notre-dame-de-paris.1ef24045.jpg";